import React from "react";
import { isMobile } from "react-device-detect";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { HERO_CAROUSELS } from "../../gqlOperations/queries";
import useStyles from "./styles";
import DesktopCarousel from "./DesktopCarousel";
import DeskCarouselCard from "./DeskCarouselCard";
import MobileCarousel from "./MobileCarousel";
import SocialMedia from "./SocialMediaSection/SocialMedia";

const Carousels = (props) => {
  const classes = useStyles();

  const { error, loading, data } = useQuery(HERO_CAROUSELS);

  const carouselsData = data?.heroCarousels.data.map(
    (imgs) => imgs?.attributes?.imageURL,
  );

  return (
    <>
      <div className={classes.socialArea}>
        <div className={classes.gameHostBanner}>
          <div className={classes.gameHostBannerContent}>
            <div className={classes.gameHostBall}>
              <img
                src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/fire-ball-new.png"
                alt=""
                className={classes.gameHostBallImage}
              />
            </div>

            <div className={classes.newBadge}>NEW:</div>

            <div className={classes.gameHostText}>
              <span className={classes.gameHostTextFirstLine}>
                <span className={classes.gameHostTextSpan}>GOT A GAME?</span>{" "}
                WE'LL HELP YOU&nbsp;
              </span>

              <span className={classes.gameHostTextSecondLine}>
                ORGANISE IT
              </span>
            </div>

            <Link to="/games" className={classes.hostGameButton}>
              HOST YOUR GAME
              <span className={classes.hostGameArrow}>→</span>
            </Link>
          </div>
        </div>
      </div>
      {/* {isMobile ? <MobileCarousel /> : <DesktopCarousel data={carouselsData} loading={loading} />} */}
      {isMobile ? "" : <SocialMedia />}
      {<DeskCarouselCard />}
    </>
  );
};

export default Carousels;
